import React, { Component } from 'react';
import _validator from 'modules/validator';
import _AdminService from 'modules/AdminService';
import DropdownList from 'components/controls/DropdownList';
import { Button } from 'antd';
import _notification from 'modules/notification';
import { Card, Modal, Input, Switch, Radio, Pagination, Checkbox } from 'antd';
import ConfirmPopup from '../popup/ConfirmPopup';
import MyInput from 'components/controls/MyInput';
import { GENERAL_ERROR_MESSAGE } from 'constants/constants';
import moment from 'moment';
import CandidateReview from './CandidateReview_new';
import ButtonComponent from 'components/controls/Button';
import { instance } from '../../modules/ApiRequest';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
import EmptyState from 'components/enterprise/EmptyState';
import StatusBadge from 'components/enterprise/StatusBadge';
import _csvExport from 'modules/csvExport';
import PageHeader from 'components/enterprise/PageHeader';
import { routesAdmin } from 'routes/Routes';
const { Search } = Input;


class CandidatesList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: { pageSize: 100, current: 1, total: 0 },
            highlightedRowID: 0,
            data: [],
            category: [],
            degree: [],
            rowData: {},
            isAllStudentRegisterData: false ,
            loading: false,
            showModel: true,
            showMessageBox: false,
            categoryError: "",
            degreeError: "",
            totalRowCount: 0,
            showCandidateReview: false,
            selectedRowKeys: [],
            searchTerm: "",
            showAll: false,
            txnMatched: "All",
            postList: [],
            hideBuldActions: false
        };
    }

    componentDidMount() {
        console.clear();
        this.getAllCandidates();
        this.getAllPosts();
    }

    //API operations
    getAllCandidates = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let candidateList = await _AdminService.GetAllCandidates(this.state.pagination.current,this.state.pagination.pageSize,this.state.isAllStudentRegisterData);
                    //console.log("categoryList Data: ", candidateList.data);
                    // console.log(this.state.data ? [...new Set(candidateList.data.List.map(item => item.Category ? item.Category : "A"))] : []);

                    let searchedData = candidateList.data;

                    this.setState({
                        ...this.state,
                        data: searchedData.List,
                        pagination: { ...this.state.pagination, total: searchedData.TotalRecords },
                        category: this.state.data ? [...new Set(searchedData.List.map(item => item.Category ? item.Category : "A"))] : [],
                        totalRowCount: searchedData.TotalRecords,
                        loading: false,
                        selectedRowKeys: [],
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    getAllPosts = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let postList = await _AdminService.GetAllPost();

                    this.setState({
                        ...this.state,
                        postList: postList.data,
                        loading: false,
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    search = async () => {
        try {
            //console.log(this.state.searchTerm, 'pagination: ', this.state.pagination);
            this.setState({ loading: true }, async () => {
                try {
                    let candidateList = await _AdminService.SearchCandidates(this.state.pagination.current, this.state.pagination.pageSize, this.state.isAllStudentRegisterData,this.state.searchTerm, this.state.txnMatched);
                    let searchedData = candidateList.data;

                    // console.log("searched Data: ", searchedData);
                    // console.log(this.state.data ? [...new Set(searchedData.List.map(item => item.Category ? item.Category : "A"))] : []);

                    this.setState({
                        ...this.state,
                        data: searchedData.List,
                        pagination: { ...this.state.pagination, total: searchedData.TotalRecords },
                        category: this.state.data ? [...new Set(searchedData.List.map(item => item.Category ? item.Category : "A"))] : [],
                        totalRowCount: searchedData.TotalRecords,
                        loading: false,
                        selectedRowKeys: [],
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    onBulkApproveReject = async (flag) => {
        try {

            if (this.state.selectedRowKeys.length == 0) {
                _notification.showMessage('error', "Please select at least one candidate.");
                return;
            }

            //console.log(this.state.searchTerm, 'pagination: ', this.state.pagination);
            this.setState({ loading: true }, async () => {
                try {

                    const params = {
                        ApplicationIds: this.state.selectedRowKeys,
                        IsApprovedRejectedStatus: flag == 1 ? true : false
                    }

                    const response = await _AdminService.UpdateBulkApprovedOrRejectedStatus(params);

                    if (response.status == 200) {
                        _notification.showMessage('success', `Bulk Forms ${flag == 1 ? "Approved" : "Rejected"} successfully.`);
                        this.setState({
                            post: "",
                            postError: "",
                            showModel: false,
                            loading: false,
                            highlightedRowID: params.Id
                        });
                        this.search();
                    }
                    else {
                        _notification.showMessage('error', response.data.message);
                    }

                    //this.search();//Calling this to refresh current page
                    //
                    this.setState({
                        loading: false,
                        selectedRowKeys: [],
                    });
                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    onSearch = (value) => {
        //console.log("Searched: ", value);
        this.setState({ searchTerm: value, pagination: { ...this.state.pagination, current: 1 }, });
        this.search();
    }

    onAllChange = (checked) => {
        this.setState({ showAll: checked, pagination: { ...this.state.pagination, current: 1, pageSize: checked ? 999999 : 5 }, });
        this.search();
    }

    onTxnMatchUnmatchChange = (value) => {
        //console.log(value.target.value);
        this.setState({ txnMatched: value.target.value, pagination: { ...this.state.pagination, current: 1 } });
        this.search();
    }

    onApproveRejectChange = (value) => {
        this.search();//Calling this to refresh current page
    }

    closeReviewModal(value = false) {
        this.setState({ showMessageBox: value, showCandidateReview: false });
    }

    getNextPendingCandidate = (currentApplicationId) => {
        const currentIndex = this.state.data.findIndex(x => x.Application_Id === currentApplicationId);
        if (currentIndex === -1) {
            return null;
        }
        return this.state.data.slice(currentIndex + 1).find(x => x.Is_Submitted && x.Is_Approved_Rejected === 0) || null;
    }

    onAdvanceOrClose = (currentApplicationId) => {
        const next = this.getNextPendingCandidate(currentApplicationId);
        this.search();//Refresh the list in the background
        if (next) {
            this.setState({ rowData: next });
            return true;
        }
        this.setState({ showCandidateReview: false });
        return false;
    }

    onSearchTextChange = ({ target: { name, value } }) => {
        this.setState({
            ...this.state,
            searchTerm: value
        });
    }

    // Html table events
    // onHtmlEditClick = record => {
    //     console.log(record);
    // }

    onPageChange = (pageNumber) => {
        //console.log(pageNumber);
        this.setState({ pagination: { ...this.state.pagination, current: pageNumber }, });
        this.search();
    }

    onChange = (e) => {
        this.setState({
          isAllStudentRegisterData: e.target.checked,
          pagination: { ...this.state.pagination, current: 1 }
       
        }, () => {
            // this.getAllCandidates(); 
            this.search();
        });
    };

    onExportCsv = () => {
        const columns = [
            { title: 'Form #', dataIndex: 'Form_Number' },
            { title: 'Name', dataIndex: (row) => `${row.First_Name || ''} ${row.Middle_Name || ''} ${row.Last_Name || ''}`.replace(/\s+/g, ' ').trim() },
            { title: 'Applied Post', dataIndex: 'Applied_Post' },
            { title: 'Gender', dataIndex: 'Gender' },
            { title: 'Mobile No.', dataIndex: 'Mobile_Number' },
            { title: 'Status', dataIndex: 'Marital_Status' },
            { title: 'Category', dataIndex: 'Category' },
            { title: 'Caste', dataIndex: 'Caste' },
            { title: 'State', dataIndex: 'State' },
            { title: 'District', dataIndex: 'District' },
            { title: 'Taluka', dataIndex: 'Taluka' },
            { title: 'Transaction', dataIndex: 'Challan_Transaction_Id' }
        ];
        _csvExport.exportToCsv(`candidates-page-${this.state.pagination.current}.csv`, columns, this.state.data);
    };

    onShowSizeChange = (current, pageSize) => {
        //console.log(current, pageSize);
        this.setState({ pagination: { ...this.state.pagination, current: 1, pageSize: pageSize }, });
        this.search();
    };

    onHtmlEditClick = (value) => {
        //console.log('params ', value);        
        this.setState({ rowData: value, showModel: true, highlightedRowID: 0, showCandidateReview: true });
    };

    onHtmlSelectRow = studentID => {
        //console.log(studentID);
        let tempKeys = this.state.selectedRowKeys;
        if (tempKeys.includes(studentID)) {
            this.setState({ selectedRowKeys: tempKeys.filter((value) => value != studentID) }, async () => {
                this.isValidSelectedRecords();
            });
        }
        else {
            tempKeys.push(studentID);
            this.setState({ selectedRowKeys: tempKeys }, async () => {
                this.isValidSelectedRecords();
            });
        }
    }

    onHtmlSelectAll = (e) => {

        console.log('value of checkbox : ', e.target.checked);

        //this.setState({ selectedRowKeys: this.state.data.map(a => a.Id) });
        var myTable = document.getElementById('myTable');
        let cbox = myTable.querySelectorAll("input[type='checkbox']");

        for (var i = 1; i < cbox.length; i++) {
            cbox[i].checked = e.target.checked;
        }

        if (e.target.checked) {
            this.setState({ selectedRowKeys: this.state.data.map(a => a.Id) }, async () => {
                this.isValidSelectedRecords();
            });
        }
        else {
            this.setState({ selectedRowKeys: [] }, async () => {
                this.isValidSelectedRecords();
            });
        }

    }

    onContains = (arr, values) => {
        return values.every(value => {
            return arr.includes(value);
        });
    }

    isValidSelectedRecords = () => {

        this.setState({ hideBuldActions: false }, async () => {

            if (!this.state.selectedRowKeys.length) {
                return;
            }

            var rollNumberGeneratedPosts = this.state.postList.filter(x => x.RollNumbersGenerated == true).map(x => x.Id);
            var allRecords = this.state.data.filter(x => rollNumberGeneratedPosts.includes(x.Applied_PostId)).map(x => x.Id);
            var includesAny = allRecords.filter(x => this.state.selectedRowKeys.includes(x)).map(x => x);

            if (includesAny.length) {
                this.setState({ hideBuldActions: true });
            }
            else {
                this.setState({ hideBuldActions: false });
            }
        });
    }

    render() {
        const candidateReviewPopup = (<Modal
            centered={true}
            width={950}
            bodyStyle={{
                height: "550px",
                padding: 20,
                paddingTop: 20,
                alignItems: "center",
                justifyContent: "center",
                //display: " flex"
            }}
            className="modelPopAnt admin-popup"
            visible={this.state.showCandidateReview}
            onCancel={() => this.closeReviewModal(false)}
            footer={false}
        >
            <CandidateReview
                onCancel={() => this.closeReviewModal(false)}
                onStateChange={this.onApproveRejectChange}
                onAdvanceOrClose={this.onAdvanceOrClose}
                popupData={this.state.rowData}
                message="Are you sure, you want to delete this post?"
            />
        </Modal>);

        if (this.state.loading)
            return <LoadingSpinner />

        return (
            <div className="pb-4 admin-custom-table mb-4">
                <PageHeader
                    title="Candidates List"
                    subtitle="Search, review, and manage candidate registrations."
                    breadcrumbItems={[{ label: 'Dashboard', path: routesAdmin.dashboard.path }, { label: 'Candidates List' }]}
                />

                <div className="ent-panel mb-3">
                    <div className="search-wrap ">
                        <Search
                            placeholder="Search Form No., Name, Post, Phone, Category, District, State, Taluka"
                            allowClear
                            onSearch={this.onSearch}
                            value={this.state.searchTerm}
                            onChange={this.onSearchTextChange}
                            style={{
                                width: 460,
                                paddingLeft: '7px'
                            }}
                        />

                        <Switch defaultChecked={this.state.showAll} onChange={this.onAllChange} style={{ alignSelf: 'center', marginLeft: "10px" }}
                            checkedChildren="Show All" unCheckedChildren="Show All" />
                        
                        <Radio.Group className="radioButtons" defaultValue={this.state.txnMatched} onChange={this.onTxnMatchUnmatchChange} buttonStyle="solid" style={{ alignSelf: 'center', marginLeft: "10px" }}>
                            <Radio.Button value="All">All</Radio.Button>
                            <Radio.Button value="Match">Txn Matched</Radio.Button>
                            <Radio.Button value="UnMatch">Txn Unmatched</Radio.Button>
                        </Radio.Group>
                        
                        {(this.state.selectedRowKeys.length && !this.state.hideBuldActions) ? <Button 
                            id="btnApprove"
                            value="Approve"
                            size='small'
                            onClick={() => this.onBulkApproveReject(1)}
                            className="button-global button-primary ml-3 mr-2 mid autoHeight" >Approve Selected</Button> : <></>}  

                        {(this.state.selectedRowKeys.length && !this.state.hideBuldActions) ? <Button
                            id="btnReject" color="red"
                            value="Reject"
                            size='small'
                            onClick={() => this.onBulkApproveReject(2)}
                            className="button-global button-border removebutton mid ml-2 autoHeight" >Reject Selected</Button> : <></>}

                        {(this.state.selectedRowKeys.length && this.state.hideBuldActions) ?
                            <span className="ml-3 text-danger" style={{ alignSelf: 'center' }}>
                                Bulk actions unavailable: selection includes a post whose roll numbers are already generated.
                            </span> : <></>}

                        <Checkbox
                            onChange={this.onChange}
                            checked={this.state.isAllStudentRegisterData}
                            style={{ marginLeft: "10px", marginTop: "6px", marginRight: '10px' }}
                        >
                            Show All Candidate Register Data
                        </Checkbox>

                        <Button
                            size='small'
                            onClick={this.onExportCsv}
                            disabled={!this.state.data.length}
                            className="button-global button-secondary ml-2 autoHeight"
                            title="Exports only the currently loaded page of results"
                        >Export current page (CSV)</Button>


                    </div>
                </div>

                
                <div className="custom-table-wrap  admin-table table-striped-rows ent-panel">
                    <div className=" analysisWrap ant-table-small" >
                        <div className="ant-table-content">
                            <div className="ant-table-body">
                                <table className='customTable table-striped-rows whiteBg' id="myTable">
                                    <thead className="ant-table-thead"> 
                                        <tr className='stickyDiv'>
                                            <th style={{ width: '2%' }}><input type="checkbox" className='customTableAllCheckbox' onClick={this.onHtmlSelectAll.bind(this)} aria-label="Select all candidates" /></th>
                                            <th style={{ width: '7%' }}>Form #</th>
                                            <th style={{ width: '22%' }}>Name</th>
                                            <th style={{ width: '10%' }}>Applied Post</th>
                                            <th style={{ width: '5%' }}>Gender</th>
                                            <th style={{ width: '9%' }}>Mobile No.</th>
                                            <th style={{ width: '5%' }}>Status</th>
                                            <th style={{ width: '4%' }}>Age</th>
                                            <th style={{ width: '5%' }}>Category</th>
                                            <th style={{ width: '7%' }}>Caste</th>
                                            <th style={{ width: '7%' }}>State</th>
                                            <th style={{ width: '7%' }}>District</th>
                                            <th style={{ width: '7%' }}>Taluka</th>
                                            <th style={{ width: '9%' }}>Transaction</th>
                                            <th style={{ width: '7%' }}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody  className='ant-table-tbody '>
                                        
                                        {this.state.data.map((item, index) => (

                                            <tr data-index={index} key={item.Id}>
                                                <td><input type="checkbox" className='customTableCellCheckbox' onClick={(enent) => this.onHtmlSelectRow(item.Id)} aria-label={`Select candidate ${item.Form_Number || ''}`} /></td>
                                                <td>{item.Form_Number}</td>
                                                <td>{item.First_Name + ' ' + item.Middle_Name + ' ' + item.Last_Name}</td>
                                                <td style={{ lineHeight: '15px' }}>{item.Applied_Post}</td>
                                                <td>{item.Gender}</td>
                                                <td>{item.Mobile_Number}</td>
                                                <td>{item.Marital_Status}</td>
                                                <td>{moment().diff(item.Birth_Date, 'years')}</td>
                                                <td>{item.Category}</td>
                                                <td>{item.Caste}</td>
                                                <td>{item.State}</td>
                                                <td>{item.District}</td>
                                                <td>{item.Taluka}</td>
                                                <td>
                                                    <span>
                                                        {item.Challan_Transaction_Id}
                                                        {item.Submitted_Challan_Transaction_Id && (
                                                            item.Challan_Transaction_Id == item.Submitted_Challan_Transaction_Id
                                                                ? <StatusBadge status="Matched" tone="success" />
                                                                : <StatusBadge status="Unmatched" tone="error" />
                                                        )}
                                                    </span>
                                                </td>
                                                <td>
                                                    {item.Is_Submitted ?
                                                        <span
                                                            onClick={(event) => this.onHtmlEditClick(item)}
                                                            role="button"
                                                            tabIndex={0}
                                                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { this.onHtmlEditClick(item); } }}
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            <StatusBadge
                                                                status={item.Is_Approved_Rejected == 0 ? "Review" :
                                                                    item.Roll_Number ? 'View' : (item.Is_Approved_Rejected == 1 ? "Approved" : "Rejected")}
                                                                tone={item.Is_Approved_Rejected == 0 ? "info" : (item.Is_Approved_Rejected == 1 ? "success" : "error")}
                                                            />
                                                        </span> : <></>}
                                                </td>

                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                {!this.state.data.length ?
                                    <EmptyState icon="inbox" title="No Records Found" description="No candidates match the current search or filter criteria." />
                                    : ""}
                            </div>
                            <div className="ant-table-footer ">

                                    <div className="d-flex align-items-center justify-content-end">
                                        {this.state.selectedRowKeys.length ?
                                        <label style={{  marginRight: '20px', color: 'darkgreen' }}>Selected Records: {this.state.selectedRowKeys.length}</label>
                                        : <></>}
                                        <label style={{  marginRight: '20px' }}>Total Records: {this.state.totalRowCount}</label>        
                                    </div> 
                                
                            </div>
                        
                        </div>
                    </div>
                    <Pagination
                        showSizeChanger
                        pageSizeOptions={['100', '200', '300', '500', '1000']}
                        onShowSizeChange={this.onShowSizeChange}
                        onChange={this.onPageChange}
                        defaultCurrent={this.state.pagination.current}
                        total={this.state.pagination.total}
                        pageSize={this.state.pagination.pageSize}
                        className="ant-table-pagination mini"
                    />  
                       
                </div>     
                {this.state.showCandidateReview ? candidateReviewPopup : <></>}                        
                
            </div>)



    };
}

export default CandidatesList;